import { BASE_PATH } from '@/consts/environmental';

import { createCurologyApiUrls } from './createApiUrls';
import { createHydrogenUrls } from './createHydrogenUrls';
import { createCurologyLegacyUrls } from './createLegacyUrls';
import { createCurologySiteUrls } from './createSiteUrls';

const appUrl = process.env.NEXT_PUBLIC_CUROLOGY_APP_URL;
const siteUrl = process.env.NEXT_PUBLIC_CUROLOGY_SITE_URL;
const hydrogenUrl = process.env.NEXT_PUBLIC_CUROLOGY_HYDROGEN_URL;

export const curologyUrls = {
  base: `${appUrl}${BASE_PATH}`,
  api: createCurologyApiUrls(appUrl),
  legacy: createCurologyLegacyUrls(appUrl),
  site: createCurologySiteUrls(siteUrl),
  hydrogen: createHydrogenUrls(hydrogenUrl),
};
